/* eslint-disable */
import React, { Component, } from 'react'
import { PropTypes, } from 'prop-types';

import { saveOrder, } from 'ggApp/modules/order/storage';

export function OverwriteOrder(WrappedComponent) {
    class OverwriteOrder extends Component {
        constructor(props) {
            super(props);
            const {
                inlineOrderNumber,
                storeCode,
            } = this.props;

            if(inlineOrderNumber) {
                saveOrder(storeCode, inlineOrderNumber);
            }
        }

        render() { return <WrappedComponent {...this.props} />; }
    }

    OverwriteOrder.propTypes = {
        inlineOrderNumber: PropTypes.string,
        storeCode: PropTypes.string.isRequired,
    }

    return OverwriteOrder;
}

